'use strict';

$(document).on('click', '.productLinkto.productLinktoShade-desktop', function() {
    if ($('.productLinkto.productLinktoShade-desktop').hasClass('disabled')) {
        return;
    }

    var selectedProductShadeID;

    if ($('.shade-circle-wrapper').length) {
        selectedProductShadeID = $('.shade-circle-wrapper svg.active').parent().attr('data-attr-value');
    } else {
        selectedProductShadeID = $(".owl-item.focused .shadefinder-shadesquare").attr('data-shade-id');
    }

    // First change shade & after simulate click on add to cart button
    if (selectedProductShadeID) {
        if ($('.swatch-full-palette .color-value').length > 0) {
            // Case when more than one shade is available for the product
            $('.swatch-full-palette .color-value').each(function() {
                if ($(this).attr('data-attr-value') === selectedProductShadeID){
                    if (window.YMK.isLoaded()) {
                        window.YMK.close();
                    } else {
                        $("#vto-sf-modal .close").trigger("click");
                    }
                    // Simulate click
                    $(this).trigger('click');
                
                    setTimeout(() => {
                        // Simulate add to cart
                        $('button.add-to-cart').first().click();
                    }, 750);
                }
            });
        } else {
            // Case when only one shade available for the product
            if (window.YMK.isLoaded()) {
                window.YMK.close();
            } else {
                $("#vto-sf-modal .close").trigger("click");
            }
            // Simulate add to cart
            $('button.add-to-cart').first().click();
        }
    }
    setTimeout(() => {
        $("#vto-sf-modal").spinner().stop();
    }, 1000);
});
